import { SET_FLAGS, SET_FLAGS_IS_FETCHED } from '@/utils/store/mutationTypes'

export default {
  /**
   * Set flags
   *
   * @param state
   * @param flags
   */
  [SET_FLAGS] (state, { flags }) {
    state.flags = flags
  },

  /**
   * Set flags is fetched
   *
   * @param state
   * @param isFetched
   */
  [SET_FLAGS_IS_FETCHED] (state, { isFetched }) {
    state.isFetched = isFetched
  }
}
